import { z } from "zod";
import { GOAL_STATUSES, ISSUE_PRIORITIES, GOAL_MESSAGE_TYPES } from "../constants.js";
export const createGoalSchema = z.object({
    companyId: z.string().uuid(),
    title: z.string().min(1).max(500),
    description: z.string().max(5000).optional(),
    parentId: z.string().uuid().nullable().optional(),
    ownerId: z.string().uuid().nullable().optional(),
    targetDate: z.string().datetime().nullable().optional(),
    cronExpression: z.string().max(100).optional(),
    timezone: z.string().max(100).optional(),
});
export const updateGoalSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    description: z.string().max(5000).nullable().optional(),
    status: z.enum(GOAL_STATUSES).optional(),
    parentId: z.string().uuid().nullable().optional(),
    ownerId: z.string().uuid().nullable().optional(),
    targetDate: z.string().datetime().nullable().optional(),
});
export const planGoalSchema = z.object({
    tasks: z.array(z.object({
        title: z.string().min(1).max(500),
        description: z.string().max(10000).optional(),
        priority: z.enum(ISSUE_PRIORITIES).optional(),
        assigneeAgentId: z.string().uuid().nullable().optional(),
        parentId: z.string().uuid().nullable().optional(),
    })).min(1).max(50),
});
export const createGoalMessageSchema = z.object({
    content: z.string().min(1).max(10000),
    messageType: z.enum(GOAL_MESSAGE_TYPES).optional(),
    metadata: z.record(z.unknown()).optional(),
});
//# sourceMappingURL=goal.js.map